import { Pipe, PipeTransform } from '@angular/core';
import { Currency, MoneyPipe } from '@interticket/core';
import { IPriceInterval } from '@core/interfaces/price/price-interval.interface';
import { PriceCategory } from '@core/models/product/price-category.model';

@Pipe({
  name: 'priceInterval',
})
export class PriceIntervalPipe implements PipeTransform {

  constructor(
    private moneyPipe: MoneyPipe
  ) { }

  transform(priceCategories: PriceCategory[], currency: Currency): any {
    if (!priceCategories || !priceCategories.length) {
      return '';
    }

    if (priceCategories.length === 1) {
      return this.moneyPipe.transform(priceCategories[0].price, currency);
    }

    const priceInterval: IPriceInterval = priceCategories.reduce((interval: IPriceInterval, priceCategory: PriceCategory, index: number) => {
      if (index === 0) {
        return { min: priceCategory.price, max: priceCategory.price };
      } else if (priceCategory.price < interval.min) {
        return { ...interval, min: priceCategory.price };
      } else if (priceCategory.price > interval.max) {
        return { ...interval, max: priceCategory.price };
      } else {
        return interval;
      }
    }, { min: null, max: null });

    if (priceInterval.max === priceInterval.min) {
      return this.moneyPipe.transform(priceInterval.min, currency);
    }

    return this.moneyPipe.transform(priceInterval.min, currency) + ' - ' + this.moneyPipe.transform(priceInterval.max, currency);
  }

}
